import { render, staticRenderFns } from "./DeliveryBillingForm.vue?vue&type=template&id=1e8855a5&scoped=true"
import script from "./DeliveryBillingForm.vue?vue&type=script&lang=js"
export * from "./DeliveryBillingForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e8855a5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e8855a5')) {
      api.createRecord('1e8855a5', component.options)
    } else {
      api.reload('1e8855a5', component.options)
    }
    module.hot.accept("./DeliveryBillingForm.vue?vue&type=template&id=1e8855a5&scoped=true", function () {
      api.rerender('1e8855a5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/assets/js/Components/DeliveryBillingForm.vue"
export default component.exports